import { render, staticRenderFns } from "./ModalResetStudy.vue?vue&type=template&id=3005cb2b&scoped=true&lang=pug&"
import script from "./ModalResetStudy.vue?vue&type=script&lang=ts&"
export * from "./ModalResetStudy.vue?vue&type=script&lang=ts&"
import style0 from "./ModalResetStudy.vue?vue&type=style&index=0&id=3005cb2b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3005cb2b",
  null
  
)

export default component.exports